const formatItems = items => items.reduce((prev, next) => {
  const formatted = {
    productId: next.product.productId,
    skuNumber: next.product.sku,
    brand: next.product.brand.name,
    part: next.product.part.name,
    title: next.product.title,
    mfrNumber: next.product.mfrNumber,
    vehicle: (next.modifiers && next.modifiers.vehicle && next.modifiers.vehicle.details) || {},
    protectionPlan: (next.warranty && next.warranty.customerProtectionPlan) || {},
    corePrice: next.product.price.corePrice,
    image: next.product.image.url,
    listPrice: next.product.price.regular,
    skuStatus: next.product.skuStatus,
    isUniversal: next.product.isUniversal,
    isClearance: next.product.isClearance,
    isPlBrand: next.product.isPlBrand,
    isVendor: next.product.isVendor,
    isPla: next.referrer && next.referrer.toLowerCase().indexOf('tid=') > -1,
    team_id: next.product.teamId,
    quantity: next.modifiers.quantity,
    category: next.product.category,
    ...(next?.product?.catalogType && { catalogType: next.product.catalogType }),
  }
  return [
    ...prev,
    formatted,
  ]
}, [])

export default formatItems
